import './App.css';


const NoPage = () => {
    return <div><h1>404</h1>
    <p>Well how did you get here then? Probably best to go back <a href='/'>home</a> and try again...</p>
  </div>;
  };
  
  export default NoPage;